<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { Label, type LabelProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

// eslint-disable-next-line unicorn/prevent-abbreviations
const props = defineProps<LabelProps & { class?: HTMLAttributes['class'] }>()

// eslint-disable-next-line unicorn/prevent-abbreviations
const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
  <Label v-bind="delegatedProps" :class="cn('atabix-input-label', props.class)">
    <slot />
  </Label>
</template>

<style lang="scss">
.atabix-input-label {
  @apply text-base font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70;
  @apply block h-[17px];
}
</style>
